const { VITE_CONVERSATIONS_API } = import.meta.env;

// Mirrors `KnowledgeArticleSummary` / `KnowledgeArticle` in
// `conversations_types/schemas.py`.
export interface KnowledgeArticleSummary {
  slug: string;
  title: string;
  summary: string;
  keywords: string[];
  // `draft` until whoever owns that part of the product has reviewed it.
  status: "draft" | "reviewed";
}

export interface KnowledgeArticle extends KnowledgeArticleSummary {
  // The article text, as markdown, without its frontmatter.
  body: string;
}

export const knowledgeBasePath = () => `${VITE_CONVERSATIONS_API}/kb`;

export const knowledgeArticlePath = (slug: string) =>
  `${knowledgeBasePath()}/${encodeURIComponent(slug)}`;
